module.exports = __webpack_public_path__ + "static/media/AGS21_Promo_Script_1611689195182.b010033c.docx";